import React, { forwardRef, useEffect, useState, useRef } from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Radio,
  Upload,
  Button,
  Spin,
} from "antd";
import axios from "axios";
import API from "@/api";
import { PlusOutlined } from "@ant-design/icons";

function MxsjFormDetail(props, ref) {
  const formRef = useRef();
  const { userInfo, type, types, selectedRow } = props;
  const [fileList, setFileList] = useState([]);
  const [detail, setDetail] = useState({});
  const [spinning, setSpinning] = useState(true);
  const layout = {
    labelCol: {
      span: 8,
      style: { textAlign: "right", whiteSpace: "normal" },
    },
    wrapperCol: {
      span: 16,
    },
  };

  useEffect(() => {
    if (type === "edit" || type === "see" || type === "check") {
      axios.get(API.mxsjDetail + `?id=${selectedRow?.id}`).then((res) => {
        const data = res?.data?.result?.data;

        if (data.iconKey) {
          setFileList([
            {
              uid: data.iconKey,
              status: "done",
              url: data.iconPath,
              uuid: data.iconKey,
            },
          ]);
        }

        setDetail(data);
        setSpinning(false);
      });
    } else {
      setSpinning(false);
    }
  }, []);

  if (ref) {
    ref.current = {
      getValue: () => {
        return {
          ...formRef.current?.getFieldsValue(),
          iconKey: fileList?.[0]?.uid || "",
          iconPath: fileList?.[0]?.url || "",
        };
      },
      verify: async () => {
        try {
          return await formRef.current.validateFields();
        } catch {
          return Promise.reject();
        }
      },
    };
  }

  // 封装File转Base64的异步函数（复用性更高）
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      // 读取文件为Base64 DataURL（核心API）
      reader.readAsDataURL(file);
      // 读取成功的回调
      reader.onload = () => resolve(reader.result); // result就是Base64字符串
      // 读取失败的回调
      reader.onerror = (err) => reject(err);
    });
  };

  return (
    <Spin spinning={spinning}>
      {!spinning ? (
        <Form
          ref={formRef}
          style={{
            padding: "25px 0",
          }}
          initialValues={
            type === "add"
              ? {
                  userCode: userInfo?.code,
                  userName: userInfo?.name,
                  orgName: userInfo?.orgs?.[0]?.name,
                  phone: userInfo?.phone,
                  email: userInfo?.email,
                }
              : {
                  ...detail,
                  status: detail?.status * 1 === 1 ? "" : detail?.status,
                }
          }
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item {...layout} label="工号" name="userCode">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="姓名" name="userName">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="单位" name="orgName">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label="联系方式"
                rules={[
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: "请输入有效的手机号",
                  },
                ]}
                name="phone"
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="邮箱"
                name="email"
                rules={[
                  {
                    type: "email",
                  },
                ]}
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "请填写模型ID",
                  },
                ]}
                {...layout}
                label="模型ID"
                name="sourceModelId"
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "请填写模型名称",
                  },
                ]}
                {...layout}
                label="模型名称"
                name="name"
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "请选择模型类型",
                  },
                ]}
                {...layout}
                label="模型类型"
                name="category"
              >
                <Select
                  options={types}
                  allowClear
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="参数规模" name="paramSize">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="上下文长度" name="context">
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label="部署分类" name="deploymentType">
                <Select
                  options={[
                    {
                      label: "本地",
                      value: "local",
                    },
                    {
                      label: "云端",
                      value: "cloud",
                    },
                  ]}
                  allowClear
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="接口地址"
                name="baseUrl"
                rules={[
                  {
                    required: true,
                    message: "请填写接口地址",
                  },
                ]}
              >
                <Input disabled={type === "add" ? false : true} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="API密钥"
                name="apiKey"
                rules={[
                  {
                    required: true,
                    message: "请填写API密钥",
                  },
                ]}
              >
                {type === "add" ? (
                  <Input disabled={type === "add" ? false : true} />
                ) : (
                  <Input.Password disabled={type === "add" ? false : true} />
                )}
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="图标"
                name="files"
              >
                <Upload
                  maxCount={1}
                  fileList={fileList}
                  onChange={() => {}}
                  listType="picture-card"
                  beforeUpload={() => {}}
                  onRemove={() => {
                    setFileList([]);
                  }}
                  disabled={type === "add" ? false : true}
                  customRequest={async (val) => {
                    const { file } = val;
                    console.log(file);

                    try {
                      const formData = new FormData();
                      const base64Str = await fileToBase64(file);

                      file.baseImg = base64Str;
                      formData.append("files", file);
                      axios
                        .post(
                          API.uploadFile,
                          {
                            name: file?.name,
                            baseImg: file?.baseImg,
                          },
                          {
                            headers: {
                              "Content-Type": "application/json",
                            },
                          },
                        )
                        .then((res) => {
                          const data = [res?.data?.result?.data || {}];
                          const arr = [];
                          data.map((item) => {
                            arr.push({
                              uid: item.fileKey,
                              name: item.filename,
                              status: "done",
                              url: item.previewUri,
                              uuid: item.fileKey,
                              size: item.fileSize,
                            });
                          });
                          setFileList([...arr]);
                        });
                    } catch {}
                  }}
                  accept=".jpg,.jpeg,.png"
                >
                  {fileList.length >= 1 ? undefined : (
                    <Button icon={<PlusOutlined />}>上传</Button>
                  )}
                </Upload>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="模型说明"
                name="description"
                rules={[
                  {
                    required: true,
                    message: "请填写模型说明",
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 3,
                    maxRows: 6,
                  }}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="调用示例"
                name="usageExample"
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 3,
                    maxRows: 6,
                  }}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                label="返回示例"
                name="responseExample"
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 3,
                    maxRows: 6,
                  }}
                  disabled={type === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            {type === "check" || type === "see" ? (
              <>
                <Col span={24}>
                  <Form.Item
                    labelCol={{
                      span: 4,
                    }}
                    label="审核状态"
                    name="status"
                    rules={[
                      {
                        required: true,
                        message: "请选择审核状态",
                      },
                    ]}
                  >
                    <Radio.Group
                      options={[
                        {
                          label: "通过",
                          value: 2,
                        },
                        {
                          label: "驳回",
                          value: 3,
                        },
                      ]}
                      disabled={type === "see" ? true : false}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    labelCol={{
                      span: 4,
                    }}
                    label="审核意见"
                    name="auditOpinion"
                  >
                    <Input.TextArea
                      autoSize={{
                        minRows: 3,
                        maxRows: 6,
                      }}
                      disabled={type === "see" ? true : false}
                    />
                  </Form.Item>
                </Col>
              </>
            ) : undefined}
          </Row>
        </Form>
      ) : undefined}
    </Spin>
  );
}

export default forwardRef(MxsjFormDetail);
